module.exports = __webpack_public_path__ + "img/walmart-express.f1cd993f.png";